import FormStep from 'components/shared/Form/FormStep';
import Section from 'components/shared/Section';
import SectionLoader from 'components/shared/SectionLoader';
import { useFormikContext } from 'formik';

import GenericSection from '../GenericFormSection/GenericFormSection';
import { useFetchDealTypes } from '../hooks';
import { sections } from './data';
import useFetchDropdowns from './useFetchDropdowns';

const Step2 = () => {
  const { values } = useFormikContext<any>();
  const { dealTypes, loading: loadingDealTypes } = useFetchDealTypes();
  const { dropdowns, loading: loadingDropdowns } = useFetchDropdowns(values.dealType?.dealTypeId);

  if (loadingDropdowns || loadingDealTypes) return <SectionLoader />;
  if (!dealTypes || dealTypes.length === 0) {
    return <SectionLoader />;
  }

  const key = values.dealType.dealTypeKey;

  return (
    <FormStep>
      {sections.map(({ title, shouldShow, fields }) => {
        if (shouldShow && !shouldShow(key)) {
          return null;
        }

        return (
          <Section title={title} key={title}>
            <GenericSection
              dropdowns={dropdowns}
              fields={typeof fields === 'function' ? fields(key) : fields}
            />
          </Section>
        );
      })}
    </FormStep>
  );
};

export default Step2;
